module.exports = __webpack_public_path__ + "static/tutorial4-d460ac4738ee30240d79029cf89f480f.png";